exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-buttons .btn {\n  margin-right: 20px; }\n\n.modal-body {\n  text-align: justify;\n  text-justify: inter-word;\n  padding-bottom: 0px; }\n\nlabel {\n  font-style: italic;\n  font-size: 14px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/theme/components/modals/components/modalDelete/modalDelete.scss
// module id = ../../../../../src/app/theme/components/modals/components/modalDelete/modalDelete.scss
// module chunks = 11